export default "__VITE_ASSET__DWJ75085__"